import { YextSearchProps } from '@cox/core-ui8/dist/YextSearch'
export interface ReactSearchProps extends YextSearchProps {
  /**isInEditor flag returns true if page is in edit mode or returns false if page is in read only mode */
  isInEditor?: boolean
  /**jsonUrl should be the aem model.json url of expereience fragments or a page used only in storybook */
  jsonUrl?: string
  /**Spacing */
  top?: boolean
  right?: boolean
  bottom?: boolean
  left?: boolean
  /**Theme */
  lob?: string
}

export enum SearchStyleStrings {
  WHITE = 'white',
  WHITELILAC = 'whitelilac'
}
